export default {
  public: {
    loading: "Laden...",
    ok: "OK",
    cancel: "Abbrechen",
    back: "Zurück",
    userDefined: "Benutzerdefiniert",
    edit: "Bearbeiten",
    clear: "Löschen",
    delete: "Löschen",
    close: "Schließen",
    remove: "Entfernen",
    preView: "Vorschau",
    replace: "Ersetzen",
    systemMsg: "Information",
    generateSuccess: "Ihre PowerPoint-Präsentation wurde erfolgreich erstellt!",
    templateChoose:
      "Wählen Sie eine Vorlage, um Ihre eigene KI-Kreation zu vervollständigen",
    templateChooseShort: "Vorlage auswählen",
    templateChangeTips:
      "Das Ersetzen von Vorlagendaten stellt den ursprünglichen Inhalt wieder her. Geänderte Inhalte gehen verloren. Möchten Sie fortfahren?",
    sourceInvalid:
      "Die Datenquelle ist ungültig. Bitte versuchen Sie es erneut.",
    systemBusy:
      "Der Server ist ausgelastet. Bitte aktualisieren Sie die Seite.",
    templateReplaceSuccess:
      "Die Vorlage wurde erfolgreich ersetzt. Bitte speichern Sie manuell, da das System nicht automatisch speichert.",
    shareLinkTips: "Kopieren erfolgreich! Weiterleitung erfolgt jetzt!",
    noPermissionTips:
      "Entschuldigung,die Freigabeberechtigung für diese PPT wurde vom Autor geschlossen.Sie können sich bei workppt anmelden, Ihrer Fantasie freien Lauf lassen und Ihre eigene PPT erstellen!",
    copyTips: "Kopieren erfolgreich!",
    loginTips: "Bitte melden Sie sich zuerst an!",
    fontType: {
      Arial: "Arial",
      "Microsoft Yahei": "Microsoft YaHei",
      SimSun: "SimSun",
      SimHei: "SimHei",
      KaiTi: "KaiTi",
      NSimSun: "NSimSun",
      FangSong: "FangSong",
      "PingFang SC": "PingFang",
      STHeiti: "STHeiti",
      STKaiti: "STKaiti",
      STSong: "STSong",
      STFangSong: "STFangsong",
      STZhongSong: "STZhongsong",
      STHupo: "STHupo",
      STXinwei: "STXinwei",
      STLiti: "STLiti",
      STXingkai: "STXingkai",
      "Hiragino Sans GB": "Hiragino Sans",
      "Lantinghei SC": "Lantinghei",
      "Hanzipen SC": "Pianpian",
      "Hannotate SC": "Shouzhati",
      "Songti SC": "Songti",
      "Wawati SC": "Wawati",
      "Xingkai SC": "Xingkai",
      "Yuanti SC": "Yuanti",
      STXihei: "STXihei",
      YouYuan: "Youyuan",
      LiSu: "Lishu",
    },
    font: {
      font: "Schriftart",
      sysFont: "Systemschrift",
      lineFont: "Online-Schrift",
      fontColor: "Textfarbe",
      textColor: "Schriftfarbe",
      fontDelay: "Schrifthervorhebung",
      addSize: "Schriftgröße erhöhen",
      duceSize: "Schriftgröße verringern",
      left: "Linksbündig",
      middle: "Zentriert",
      horizontalCenter: "Horizontal zentriert",
      verticalCenter: "Vertikal zentriert",
      right: "Rechtsbündig",
      bottom: "Unten ausrichten",
      top: "Oben ausrichten",
      bold: "Fett",
      em: "Kursiv",
      underline: "Unterstrichen",
      strikethrough: "Durchgestrichen",
      richText: "Formatierung löschen",
      textFormat: "Formatpinsel",
      addIndex: "Einzug vergrößern",
      duceIndex: "Einzug verringern",
      no: "Nummerierung",
      link: "Hyperlink",
      inputLink: "Hyperlink eingeben",
      superscript: "Hochgestellt",
      subscript: "Tiefgestellt",
      code: "Inline-Code",
      blockquote: "Zitat",
      horizontal: "Horizontal",
      vertical: "Vertikal",
      width: "Breite",
      height: "Höhe",
      rotate: "Drehen",
      uniformHorizontal: "Horizontal verteilen",
      uniformVertical: "Vertikal verteilen",
      combine: "Kombinieren",
      unCombine: "Gruppierung aufheben",
      bgColor: "Hintergrundfarbe",
      mainColor: "Themenfarbe",
      useMainToAll: "Thema auf alle anwenden",
      preMain: "Vordefiniertes Thema",
    },
    specialEffects: {
      useAll: "Auf alle anwenden",
      no: "Keine",
      fade: "Ein-/Ausblenden",
      slideX: "Links/Rechts schieben",
      slideY: "Hoch/Runter schieben",
    },
  },
  chart: {
    insertCol: "Spalte einfügen",
    insertRow: "Zeile einfügen",
    delCol: "Spalte löschen",
    delRow: "Zeile löschen",
    merCell: "Zellen verbinden",
    unMerCell: "Zellen trennen",
    selectCurrentCol: "Aktuelle Spalte auswählen",
    selectCurrentRow: "Aktuelle Zeile auswählen",
    selectAll: "Alle Zellen auswählen",
    toTheLeft: "Nach links",
    toTheRight: "Nach rechts",
    toTheTop: "Nach oben",
    toTheBottom: "Nach unten",
  },
  desktop: {
    fileExportSuccess:
      "Die Datei wurde erfolgreich exportiert. Wählen Sie einen Speicherort aus.",
    unSupportPreviewPDF:
      "Die PDF-Vorschau ist hier nicht verfügbar. Bitte besuchen Sie die PC-Website für eine Vorschau.",
  },
  extension: {
    nonsupportDownloadPDF:
      "Das Browser-Plugin unterstützt das Herunterladen von PDFs nicht. Bitte laden Sie es von der offiziellen Website herunter.",
  },
  index: {
    createText: "PPT-Inhalt wird generiert",
    createPage: "Inhalt für Seite {0} wird generiert",
    haveProblem: "Ich habe ein Problem",
    systemError: "{0}",
    saveText: "Erfolgreich gespeichert",
    saveMessage: "Möchten Sie speichert?",
    cBtn: "Abbrechen",
    sBtn: "OK",
    waitMsg:
      "Bitte haben Sie Geduld und warten Sie 30-40 Sekunden. Falls nichts generiert wird, aktualisieren Sie Ihren Browser und versuchen Sie es erneut!",
  },
  errorCode: {
    "401":
      "Authentifizierung fehlgeschlagen, Systemressourcen nicht zugänglich",
    "403": "Aktuelle Operation nicht erlaubt",
    "404": "Resource nicht gefunden",
    default:
      "Unbekannter Systemfehler, bitte melden Sie sich beim Administrator.",
    notReDo: "Data werden verarbeitet, bitte nicht erneut senden.",
    loginMsg:
      "Ungültige Sitzung oder Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
    errMsg: "System ist ausgelastet, bitte versuchen Sie es später erneut.",
  },
  linkHandler: {
    pptPage: "Folienseite",
    change: "Ändern",
    remove: "Entfernen",
  },
  editor: {
    ctrlV: "Einfügen",
    ctrlA: "Alles auswählen",
    enter: "Neue Seite",
    f5: "Diashow",
    delete: "Seite löschen",
    ctrlD: "Seite duplizieren",
    ctrlX: "Ausschneiden",
    ctrlC: "Kopieren",
    shiftF5: "Ab aktueller Seite starten",
    positionPanel: {
      horizontalCenter: "Horizontal zentrieren",
      verticalCenter: "Vertikal zentrieren",
      horizontalVerticalCenter: "Horizontal und vertikal zentrieren",
      left: "Links ausrichten",
      right: "Rechts ausrichten",
      top: "Oben ausrichten",
      bottom: "Unten ausrichten",
      onTop: "Nach vorne bringen",
      onBottom: "Nach hinten bringen",
      levelUp: "Eine Ebene nach oben",
      levelDown: "Eine Ebene nach unten",
      setLink: "Link setzen",
      ungroup: "Gruppierung aufheben",
      group: "Gruppieren",
      selectAll: "Alles auswählen",
      lock: "Sperren",
      unlock: "Entsperren",
      delete: "Löschen",
    },
    canvas: {
      index: {
        ctrlR: "Lineal",
        ctrlW: "Gitternetzlinien",
        nl: "Keine",
        small: "Klein",
        middle: "Mittel",
        big: "Groß",
        closePan: "Auswahlpanel schließen",
        openPan: "Auswahlpanel öffnen",
        reCurrentPage: "Aktuelle Seite zurücksetzen",
        showPpt: "Diashow",
        generate: "Wird generiert...",
      },
      linkDialog: {
        url: "Bitte geben Sie die Webadresse ein",
        ppt: "Folie",
        preView: "Vorschau",
        pageUrl: "Web Link",
        pptPage: "Folienseite",
      },
    },
    canvasTool: {
      index: {
        ctrlZ: "Rückgängig",
        reSet: "Wiederherstellen",
        text: "Text einfügen",
        horizontal: "Horizontaler Textkasten",
        vertical: "Vertikal Textkasten",
        image: "Bild einfügen",
        shape: "Form einfügen",
        line: "Line einfügen",
        chart: "Diagramm einfügen",
        table: "Tabelle einfügen",
        gs: "Formel einfügen",
        voice: "Audio/Video einfügen",
        screen: "An Bildschirm anpassen",
        workspase: "Arbeitsbereich",
        save: "Speichern",
        logo: "Logo einfügen",
        close: "PPT schließen",
        share: "Aktie",
        download: "Herunterladen",
        templateReplacement: "Vorlagenersetzung",
      },
      mediaInput: {
        videoUrl: "Geben Sie die Video-URL ein, z.B. https://xxx.mp4",
        voiceUrl: "Geben Sie die Audio-URL ein, z.B. https://xxx.mp3",
        video: "Video",
        voice: "Audio",
        videoError: "Bitte geben Sie zuerst eine korrekte Video-URL ein",
        voiceError: "Bitte geben Sie zuerst eine korrekte Audio-URL ein",
      },
      tableGenerator: {
        table: "Tabelle",
        row: "Zeilen",
        column: "Spalten",
        rcError: "Zeilen/Spalten müssen zwischen 0 und 20 liegen!",
      },
      logo: {
        text1: "Firmenlogo hochladen",
        text2: "Geben Sie den Firmennamen ein",
        companyNamePlaceholder: "Geben Sie Ihren Firmennamen ein",
        single: "Auf einzelne Seite anwenden",
        all: "Auf alle Seiten anwenden",
        position: "Position",
      },
    },
    editorHeader: {
      index: {
        file: "Datei",
        importPptistFile: "pptist-Datei importieren",
        importPptxFile: "pptx-Datei importieren",
        exportPptxFile: "Datei exportieren",
        undo: "Rückgängig",
        redo: "Wiederherstellen",
        createSlide: "Seite hinzufügen",
        deleteSlide: "Seite löschen",
        closeGridLines: "Gitternetzlinien schließen",
        openGridLines: "Gitternetzlinien öffnen",
        closeRuler: "Lineal schließen",
        openRuler: "Lineal öffnen",
        resetSlides: "Folien zurücksetzen",
        closeSelectPanel: "Auswahlpanel schließen",
        openSelectPanel: "Auswahlpanel öffnen",
        f5: "Präsentieren",
        enterScreeningFromStart: "Von Anfang starten",
        enterScreening: "Von aktueller Seite starten",
        help: "Hilfe",
        hotkey: "Tastenkombinatonen",
        pptShow: "Diashow",
        export: "Exportieren",
        importing: "Wird importiert...",
        continue: "Fortsetzen",
        pauseGeneration: "Pausieren",
        noPricing:
          "Werden Sie Mitglied und genießen Sie Download-Berechtigungen mit uns.",
        noPricingToOpt: "Entsperren Sie alle Berechtigungen.",
        getTokens: "Auf Pro upgraden",
        pptSlidesMsg:
          "Glückwunsch! Sie haben {0} vollständige PPT-Folien erstellt!",
        Feedback: "Lassen Sie KI Ihr Arbeitsassistent sein.",
        giveAway: "Gutscheine verschenken (30 Minuten gültig)",
        getItNow: "Jetzt holen",
        unlockAllPpt: "Entsperren Sie alle PPT-Funktionen",
        grantPermission: "Berechtigung zur Verwendung von KI-Mindmap erteilen",
        grantPermissionToUseGpt: "Berechtigung zur Verwendung von GPT erteilen",
        permissionCodeUse:
          "Bitte merken Sie sich den Rabattcode und gehen Sie zur Zahlungsseite, um ihn zu verwenden!",
        pptTi1:
          "Sie haben alle Arbeiten abgeschlossen und insgesamt {0} Seiten PPT generiert.",
        pptTi2:
          "Sie benötigen nur den letzten Schritt, um Ihre wunderbare KI-Kreation zu erhalten!",
      },
    },
    exportDialog: {
      tips: "PPT-Download wird in der App derzeit nicht unterstützt; Bitte laden Sie es auf dem PC herunter.",
      exportScope: "Exportbereich",
      close: "Schließen",
      all: "Alle",
      thisPage: "Aktuell",
      auto: "Benutzerdefiniert",
      autoScope: "Benutzerdefinierter Bereich",
      exporting: "Wird exportiert...",
      exportImg: "Bild exportieren",
      expPdf: "Drucken / Exportieren PDF",
      expPptx: "PPTX exportieren",
      downloadSuccess:
        "Dateikonvertierung erfolgreich. Bitte wählen Sie einen Speicherpfad.",
      exportImage: {
        exportType: "Exportformat",
        imageQuality: "Bildqualität",
        ignoreFont: "Online-Schriften ignorieren",
        ignoreLineFont:
          "Standardmäßig werden Online-Schriften beim Export ignoriert. Wenn Sie Online-Schriften in der Präsentation verwendet haben und deren Stile nach dem Export beibehalten möchten, können Sie die Option ‘Online-Schriften ignorieren’ deaktivieren. Beachten Sie jedoch, dass dies die Exportzeit erhöhen kann.",
      },
      exportPdf: {
        all: "Alle Folien",
        thisPage: "Aktuelle Folie",
        pageNum: "Seiten pro Blatt",
        white: "Rand",
        notice:
          "Hinweis: Wenn die Druckvorschau nicht dem tatsächlichen Stil entspricht, überprüfen Sie die Option ‘Hintergrundgrafiken’ im  Pop-up-Druckfenster.",
      },
      exportPPTX: {
        title: "Standardvorlage überschreiben",
        notice:
          "Hinweis: Nach dem Herunterladen öffnen Sie die Datei bitte mit Microsoft Office, da andere Programme möglicherweise nicht kompatibel sind.",
      },
    },
    remark: {
      remark: "Klicken Sie, um Sprechernotizen einzugeben",
    },
    thumbnails: {
      add: "Folie hinzufügen",
      slide: "Folie",
    },
    toolbar: {
      common: {
        elementColorMask: {
          recolor: "Neu einfärben (Maske)",
          maskColor: "Maskfarbe",
          opacity: "Opazität",
        },
        elementFilter: {
          enableFilter: "Filter aktivieren",
          blur: "Verwischen",
          brightness: "Helligkeit",
          contrast: "Kontrast",
          grayscale: "Graustufen",
          saturate: "Sättigung",
          hueRotate: "Farbton drehen",
          opacity: "Opazität",
        },
        elementFlip: {
          horizontal: "Horizontal spiegeln",
          vertical: "Vertikal spiegeln",
        },
        elementOpacity: {
          opacity: "Opazität",
        },
        elementOutline: {
          border: "Rahmen aktivieren",
          borderStyle: "Rahmenstil",
          solid: "Durchgehender Rahmen",
          dashes: "Gestrichelter Rahmen",
          borderColor: "Rahmenfarbe",
          borderWeight: "Rahmenbreite",
        },
        elementShadow: {
          enable: "Schatten aktivieren",
          horizontal: "Horizontaler Schatten",
          vertical: "Vertikaler Schatten",
          fuzzyDistance: "Unschärfe Abstand",
          color: "Schattenfarbe",
        },
      },
      panel: {
        background: "Hintergrundfüllung",
        solid: "Einfarbige Füllung",
        image: "Bildfüllung",
        gradient: "Verlaufsfüllung",
        contain: "Anpassen",
        repeat: "Kacheln",
        cover: "Ausfüllen",
        linear: "Linearer Verlauf",
        radial: "Radialer Verlauf",
        startColor: "Startfarbe",
        endColor: "Endfarbe",
        rotate: "Verlaufswinkel",
        useBackgroundToAll: "Hintergrund auf alle anwenden",
      },
      elementStylePanel: {
        chartStylePanel: {
          chartDataEditor: {
            rowType: "Kategorie",
            colType: "Serie",
          },
          index: {
            edit: "Diagrammdaten bearbeiten",
            area: "Flächendiagramm-Stil",
            line: "Punktdiagramm-Stil",
            lineSmooth: "Glatte Linie verwenden",
            horizontalBars: "Balkendiagramm-Stil",
            stackBars: "Stacked Style",
            donut: "Donut-Diagramm-Stil",
            img: "Legende",
            hidden: "Ausblenden",
            showTop: "Oben anzeigen",
            showBottom: "Unten anzeigen",
            tabColor: "Gitterfarbe",
            labelColor: "Schriftfarbe",
            titleSetColor: "Themenfarben:",
            title: "Empfohlene Themen",
            titleColor: "Themenfarbe hinzufügen",
          },
        },
        audioStylePanel: {
          imgColor: "Symbolfarbe",
          autoPlay: "automatische Wiedergabe",
          loopPlay: "Schleifenwiedrgabe",
        },
        imageStylePanel: {
          cutImg: "Bild zuschneiden",
          shape: "Nach Form",
          type: "Kategorie",
          preview: "Vorschau",
          use: "Verwenden",
          searchByType: "Nach Kategorie suchen",
          uploadAndReplace: "Upload and Replace Image",
          reSetStyle: "Stil zurücksetzen",
          setBackground: "Als Hintergrund festlegen",
          clip1: "Nach Seitenverhältnis (Quadrat)",
          clip2: "Nach Seitenverhältnis (Hochformat)",
          clip3: "Nach Seitenverhältnis (Querformat)",
        },
        latexStylePanel: {
          edit: "LaTeX bearbeiten",
          color: "Farbe",
          bold: "Fett",
        },
        lineStylePanel: {
          style: "Liniestil",
          solid: "Durchgehende Linie",
          dotted: "Gepunktete Linie",
          color: "Linienfarbe",
          weight: "Linienbreite",
          startStyle: "Startstil",
          endStyle: "Endstil",
          none: "Keine",
          arrow: "Pfeil",
          dot: "Punkt",
        },
        multiStylePanel: {
          colorPicker: "Füllfarbe",
          style: "Rahmenstil",
          solid: "Durchgehender Rahmen",
          dotted: "Gepunkteter Rahmen",
          color: "Rahmenfarbe",
          weight: "Rahmenbreite",
        },
        shapeStylePanel: {
          replaceShade: "Klicken Sie, um die Form zu ersetzen",
          fill: "Einfarbige Füllung",
          gradient: "Verlaufsfüllung",
          linear: "Linearer Verlauf",
          radial: "Radialer Verlauf",
        },
        tableStylePanel: {
          colFull: "Zellenfüllung",
          row: "Zeilen",
          col: "Spalten",
          titleRow: "Titelzeile",
          totalRow: "Summenzeile",
          firstCol: "Erste Spalte",
          lastCol: "Letzte Spalte",
          titleColor: "Themenfarbe",
          themeTable: "Thementabelle",
        },
        textStylePanel: {
          urlError: "Keine korrekte Webadresse",
          command: "Aufzählungsliste",
          lineHeight: "Zeilenabstand",
          times: "Zeiten",
          paragraphSpace: "Absatzabstand",
          wordSpace: "Wortabstand",
          textIndent: "Erstzeileneinzug",
          textFill: "Textfeldfüllung",
          title: "Titel",
          titleSmall: "Untertitel",
          text: "Text",
          textSmall: "Text [Klein]",
          zs1: "Hinweis 1",
          zs2: "Hinweis 2",
        },
        videoStylePanel: {
          cover: "Video-Vorschaubild",
          recover: "Cover zurücksetzen",
        },
      },
      elementAnimationPanel: {
        addEffects: "Animation hinzufügen",
        selectAndAddEffects:
          "Elemente auf der Leinwand auswählen und Animation hinzufügen",
        time: "Dauer",
        triggerType: "Auslösertyp",
        initiative: "Aktiv auslösen",
        sameTime: "Gleichzeitig mit vorheriger",
        after: "Nach vorheriger",
        change: "Animation ändern",
        in: "Eingang",
        out: "Ausgang",
        attention: "Hervorhebung",
      },
      elementPositionPanel: {
        layer: "Ebene",
        align: "Ausrichten",
        top: "Nach vorne bringen",
        bottom: "Nach hinten bringen",
        up: "Eine Ebene nach oben",
        down: "Eine Ebene nach unten",
        noRixedRatio: "Seitenverhältnis entsperren",
        fixedRatio: "Seitenverhältnis sperren",
      },
      index: {
        style: "Stil",
        symbol: "Symbol",
        position: "Position",
        animation: "Animation",
        design: "Design",
        slideAnimation: "Übergänge",
      },
      slideDesignPanel: {
        canvasSize: "Leinwandgröße",
        wideScreen1: "Breitbild 16:9",
        wideScreen2: "Breitbild 16:10",
        standard: "Standard 4:3",
        paper: "A3 / A4 Papier",
        title: "Globales Thema",
        mainColor: "Themenfarbe",
        useMainToAll: "Thema auf alle anwenden",
        preMain: "Vordefiniertes Thema",
        text: "Text Aa",
        use: "Anwenden",
        useToAll: "Auf alle anwenden",
      },
    },
    selectPanel: {
      select: "Auswählen",
      showAll: "Alle anzeigen",
      hideAll: "Alle ausblenden",
      group: "Gruppieren",
    },
    redraw: {
      topLabel: "Neu zeichnen",
      msgTips: "Bitte geben Sie den zu generierenden Inhalt ein",
      retext: "Neu zeichnen",
      cltext: "Abbrechen",
      btnText: "Erstellen",
      reConfirm:
        "Dies ersetzt die aktuelle Seite und speichert den historischen Inhalt nicht. Möchten Sie fortfahren?",
      confirmBtnTxt: "Fortfahren",
    },
  },
  screen: {
    presenter: {
      normalView: "Normalansicht",
      pen: "Stift",
      laserPointer: "Laserpointer",
      timer: "Timer",
      exitFullScreen: "Vollbildmodus beenden",
      fullScreen: "Vollbildmodus",
      endPresentation: "Präsentation beenden",
      speakerNotes: "Sprechernotizen",
      speakersView: "Sprecheransicht",
      previousPage: "Vorherige Seite",
      nextPage: "Nächste Seite",
      firstPage: "Erste Seite",
      lastPage: "Letzte Seite",
      brushTool: "Pinselwerkzeug",
      noRemarks: "Keine Bemerkungen",
      lastPageTips: "Bereits die letzte Seite",
      firstPageTips: "Bereits die erste Seite",
      autoPlay: "Automatische Wiedergabe starten",
    },
    writingBoard: {
      inkThickness: "Tintenstärke",
      eraserSize: "Radierergröße",
      eraser: "Radierer",
      clearInk: "Tinte löschen",
      blackboard: "Tafel",
      closeBrush: "Pinsel schließen",
    },
  },
  mobile: {
    index: {
      notSupport: "Die mobile Version wird dringend entwickelt.",
      toPc: "Bitte besuchen Sie die Website auf einem PC.",
      editTips: "Bitte bearbeiten Sie auf dem PC.",
    },
  },
  useCreateElement: {
    type: "Typ{0}",
    class: "Series{0}",
  },
  components: {
    latexEditor: {
      index: {
        lateX: "LaTeXßFormel eingeben",
        preViw: "Formelvorschau",
        symbol: "Häufige Symbole",
        formula: "Vordefinierte Formeln",
        error: "Formel darf nicht leer sein",
      },
    },
    colorPicker: {
      recentUse: "Kürzlich verwendet",
    },
  },
  config: {
    latex: {
      gauss: "Gaußsche Formel",
      fourierSeries: "Fourier-Reihe",
      taylorExpansion: "Taylor-Entwicklung",
      definiteIntegral: "Bestimmtes Integral",
      trigonometricIdentity1: "Trigonometrische Identität 1",
      trigonometricIdentity2: "Trigonometrische Identität 2",
      expansion: "Summenentwicklung",
      euler: "Eulersche Formel",
      differential: "Bernoulli-Gleichung",
      totalDifferentialEquation: "Totale Differentialgleichung",
      homogeneous: "Inhomogeneo Gleichung",
      cauchy: "Cauchyscher Mittelwertsatz",
      lagrange: "Lagrangescher Mittelwertsatz",
      arcsin: "Ableitungsformel",
      trigonometric: "Trigonometrische Funktionsintegration",
      quadric: "Quadrik",
      dx: "Zweite Ableitung",
      partial: "Richtungsableitung",
      operators: "Mathematik",
      group: "Kombinationen",
      verbatim: "Functionen",
      greek: "Griechische Buchstaben",
    },
    symbol: {
      letter: "Buchstabe",
      number: "Nummer",
      math: "Mathematik`",
      arrow: "Pfeil",
      graph: "Grafik",
    },
    lines: {
      straight: "Gerade",
      brokenOrCurve: "Gebrochen oder Kurve",
    },
  },
  hotkey: {
    opt: {
      common: "Allgemein",
      ctrlX: "Ausschneiden",
      ctrlC: "Kopieren",
      ctrlV: "Einfügen",
      ctrlD: "Schnelles Kopieren und Einfügen",
      ctrlA: "Alles auswählen",
      ctrlZ: "Rückgängig",
      ctrlY: "Wiederherstellen",
      del: "Löschen",
      ctrlMore: "Mehrfachauswahl",
      ctrlP: "Drucken",
      esc: "Popup schließen",
    },
    slide: {
      show: "Diashow",
      edit: "Folie bearbeiten",
      first: "Diashow von Anfang starten",
      current: "Diashow von aktueller Seite starten",
      spacePre: "Zur vorherigen Seite wechseln",
      spaceNext1: "Zur nächsten Seite wechseln",
      spaceNext2: "Zur nächsten Seite wechseln",
      out: "Präsentation beenden",
      new: "Neue Folie",
      move: "Leinwand bewegen",
      upOrDown: "Leinwand zoomen",
      up: "Leinwand vergrößern",
      down: "Leinwand verkleinern",
      screen: "Leinwand an aktuellen Bildschirm anpassen",
      noSelectPrePage: "Vorherige Seite (nicht ausgewählte Elemente)",
      noSelectNextPage: "Nächste Seite (nicht ausgewählte Elemente)",
      prePage: "Vorherige Seite",
      nextPage: "Nächste Seite",
    },
    element: {
      opt: "Elementoperationen",
      move: "Bewegen",
      lock: "Sperren",
      combo: "Gruppieren",
      cancelCombo: "Gruppierung aufheben",
      top: "Nach vorne bringen",
      bottom: "Nach hinten bringen",
      h: "Seitenverhältnis sperren",
      v: "Horizontale/Vertikale Linie erstellen",
      change: "Fokuselement wechseln",
      com: "Bildzuschnitt bestätigen",
      text: "Text",
      image: "Bild",
      shape: "Form",
      line: "Linie",
      chart: "Diagramm",
      table: "Tabelle",
      video: "Video",
      audio: "Audio",
      latex: "Formel",
    },
    table: {
      edit: "Tabelle bearbeiten",
      nextCol: "Nächste Zelle fokussieren",
      insertTop: "Zeile oben einfügen",
      insertBottom: "Zeile unten einfügen",
      insertLeft: "Spalte links einfügen",
      insertRight: "Spalte rechts einfügen",
    },
    chat: {
      edit: "Diagrammdaten bearbeiten",
      nextLine: "Nächste Zeile fokussieren",
    },
    text: {
      edit: "Text bearbeiten",
      bold: "Fett",
      italics: "Kursiv",
      underline: "Unterstrichen",
      delLine: "Durchgestrichen",
    },
  },
  shape: {
    rectangle: "Rechteck",
    commonUse: "Häufige Formen",
    arrow: "Pfeil",
    other: "Andere Formen",
    line: "Linie",
  },
  animation: {
    in: {
      bounce: "Springen",
      bounceIn: "Hineinspringen",
      bounceInLeft: "Von links hineinspringen",
      bounceInRight: "Von rechts hineinspringen",
      bounceInUp: "Von oben hineinspringen",
      bounceInDown: "Von unten hineinspringen",
      fade: "Einblenden",
      fadeIn: "Einblenden",
      fadeInDown: "Von oben einblenden",
      fadeInDownBig: "Von oben groß einblenden",
      fadeInLeft: "Von links einblenden",
      fadeInLeftBig: "Von links groß einblenden",
      fadeInRight: "Von rechts einblenden",
      fadeInRightBig: "Von rechts groß einblenden",
      fadeInUp: "Von unten einblenden",
      fadeInUpBig: "Von unten groß einblenden",
      fadeInTopLeft: "Von oben links einblenden",
      fadeInTopRight: "Von oben rechts einblenden",
      fadeInBottomLeft: "Von unten links einblenden",
      fadeInBottomRight: "Von unten rechts einblenden",
      rotate: "Drehen",
      rotateIn: "Hineindrehen",
      rotateInDownLeft: "Nach unten links drehen",
      rotateInDownRight: "Nach unten rechts drehen",
      rotateInUpLeft: "Nach oben links drehen",
      rotateInUpRight: "Nach oben rechts drehen",
      zoom: "Zoomen",
      zoomIn: "Hineinzoomen",
      zoomInDown: "Nach unten zoomen",
      zoomInLeft: "Nach links zoomen",
      zoomInRight: "Nach rechts zoomen",
      zoomInUp: "Nach oben zoomen",
      slide: "Schieben",
      slideInDown: "Nach unten schieben",
      slideInLeft: "Nach links schieben",
      slideInRight: "Nach rechts schieben",
      slideInUp: "Nach oben schieben",
      flip: "Umdrehen",
      flipInX: "Um X-Achse drehen",
      flipInY: "Um Y-Achse drehen",
      back: "Zurück",
      backInDown: "Nach unten zurück",
      backInLeft: "Nach links zurück",
      backInRight: "Nach rechts zurück",
      backInUp: "Nach oben zurück",
      lightSpeed: "Lichtgeschwindigkeit",
      lightSpeedInRight: "Lichtgeschwindigkeit von rechts",
      lightSpeedInLeft: "Lichtgeschwindigkeit von links",
    },
    out: {
      bounce: "Springen",
      bounceOut: "Hinausspringen",
      bounceOutLeft: "Nach links hinausspringen",
      bounceOutRight: "Nach rechts hinausspringen",
      bounceOutUp: "Nach oben hinausspringen",
      bounceOutDown: "Nach unten hinausspringen",
      fade: "Ausblenden",
      fadeOut: "Ausblenden",
      fadeOutDown: "Nach unten ausblenden",
      fadeOutDownBig: "Nach unten groß ausblenden",
      fadeOutLeft: "Nach links ausblenden",
      fadeOutLeftBig: "Nach links groß ausblenden",
      fadeOutRight: "Nach rechts ausblenden",
      fadeOutRightBig: "Nach rechts groß ausblenden",
      fadeOutUp: "Nach oben ausblenden",
      fadeOutUpBig: "Nach oben groß ausblenden",
      fadeOutTopLeft: "Nach oben links ausblenden",
      fadeOutTopRight: "Nach oben rechts ausblenden",
      fadeOutBottomLeft: "Nach unten links ausblenden",
      fadeOutBottomRight: "Nach unten rechts ausblenden",
      rotate: "Drehen",
      rotateOut: "Hinausdrehen",
      rotateOutDownLeft: "Nach unten links drehen",
      rotateOutDownRight: "Nach unten rechts drehen",
      rotateOutUpLeft: "Nach oben links drehen",
      rotateOutUpRight: "Nach oben rechts drehen",
      zoom: "Zoomen",
      zoomOut: "Hinauszoomen",
      zoomOutDown: "Nach unten zoomen",
      zoomOutLeft: "Nach links zoomen",
      zoomOutRight: "Nach rechts zoomen",
      zoomOutUp: "Nach oben zoomen",
      slide: "Schieben",
      slideOutDown: "Nach unten schieben",
      slideOutLeft: "Nach links schieben",
      slideOutRight: "Nach rechts schieben",
      slideOutUp: "Nach oben schieben",
      flip: "Umdrehen",
      flipOutX: "Um X-Achse drehen",
      flipOutY: "Um Y-Achse drehen",
      back: "Zurück",
      backOutDown: "Nach unten zurück",
      backOutLeft: "Nach links zurück",
      backOutRight: "Nach rechts zurück",
      backOutUp: "Nach oben zurück",
      lightSpeed: "Lichtgeschwindigkeit",
      lightSpeedOutRight: "Lichtgeschwindigkeit nach rechts",
      lightSpeedOutLeft: "Lichtgeschwindigkeit nach links",
    },
    attention: {
      shake: "Schütteln",
      shakeX: "X-Schütteln",
      shakeY: "Y-Schütteln",
      headShake: "Kopfschütteln",
      swing: "Schwingen",
      wobble: "Wackeln",
      tada: "Tada",
      jello: "Wackelpudding",
      other: "Andere",
      bounce: "Springen",
      flash: "Aufblitzen",
      pulse: "Pulsieren",
      rubberBand: "Gummiband",
      heartBeat: "Herzschlag",
    },
  },
  requestError: {
    tokenExpires:
      "Authentifizierung fehlgeschlagen, Systemressourcen nicht zugänglich",
    permissionDenied: "Aktuelle Operation nicht erlaubt",
    notFound: "Resource nicht gefunden",
    default:
      "Unbekannter Systemfehler, bitte melden Sie sich beim Administrator.",
    exceptionReminder: "Ausnahmebehandlung",
    pleaseLogin:
      "Ungültige Sitzung oder Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
    networkError: "Netzwerkfehler",
    requestTimeOut: "System-Schnittstellenanforderung Zeitüberschreitung",
    requestFailed: "Anfrage fehlgeschlagen",
  },
  promptsText: {
    theme: [
      "Entdecken Sie verschiedene Themen und endlosen Spaß!",
      "Klicken Sie auf jede Themenseite und beginnen Sie eine magische Reise!",
      "Jedes Thema hat seinen eigenen Charme, warum nicht alle erkunden?",
      "Willkommen in der Welt der Themen, wählen Sie Ihre Interessen und beginnen Sie Ihr Abenteuer!",
      "Ihre erste KI-Diashow kommt bald, bleiben Sie dran!",
      "Beginnen Sie Ihre Diashow-Reise, Abfahrt in Kürze...",
      "Bereit für ein neues visuelles Erlebnis? Die Diashow beginnt gleich...",
      "Festhalten! Nächster Halt: Die fantastische Diashow-Reise...",
      "Schnell! Schließen Sie die Augen und warten Sie auf die überraschende Diashow...",
      "Die Diashow-Welt entfaltet sich vor Ihnen, bleiben Sie dran...",
      "Bitte haben Sie Geduld, der Traum der Diashow wird bald wahr...",
    ],
    directory: [
      "Finden Sie alles, was Sie brauchen, auf der Verzeichnisseite!",
      "Die Verzeichnisseite ist Ihr Navigationsschatz, der Ihnen hilft, schnell zu finden, was Sie brauchen!",
      "Die Verzeichnisseite bietet umfassende Navigationsdienste, damit Sie schnell Ihre Ziele finden!",
      "Unentschlossen? Finden Sie Inspiration und Richtung auf der Verzeichnisseite!",
    ],
    Content: [
      "Warten... die nächste Folie wird so bunt wie ein Regenbogen sein!",
      "Wow! Die nächste Folie wird wie ein Feuerwerk erblühen und Sie verblüffen!",
      "Geduld, die nächste Folie wird so wunderbar sein wie das Warten auf einen traumhaften Regenbogen!",
      "Spüren Sie die Magie des Wartens! Die nächste Folie wird Ihre Augen zum Leuchten bringen!",
      "Bleiben Sie dran! Die nächste Folie bringt Ihnen ein überraschendes visuelles Erlebnis!",
      "Schnell! Ziehen Sie die Vorhänge hoch, machen Sie sich bereit für das blendende Licht der nächsten Folie!",
      "Machen Sie sich bereit! Die nächste Folie bringt einen frischen visuellen Sturm!",
      "Ihre Neugier wird bald befriedigt! Die nächste Folie wird Sie überraschen!",
      "Warten... die nächste Folie nimmt Sie auf eine wunderbare visuelle Reise mit!",
      "Können Sie es kaum erwarten? Die nächste Folie wird so aufregend sein wie eine große Feier!",
      "Ratet mal, was die nächste Folie sein wird? Die Antwort wird gleich enthüllt...",
      "Bitte schnallen Sie sich an, wir fliegen gleich zur nächsten Folie...",
      "Glück kommt! Die nächste Folie rast auf Sie zu...",
      "Ratet mal, welche Farbe die nächste Folie haben wird? Die Antwort wird gleich enthüllt...",
      "Wow! Die nächste Folie bringt Ihnen unerwartete Überraschungen...",
      "Lust zu probieren? Die nächste Folie wird Ihre Neugier befriedigen...",
      "Warten... die nächste Folie bringt Ihnen Freude und Überraschungen...",
      "Warten... wie das Warten auf eine köstliche Tasse Kaffee, die nächste Folie wird Ihre Stimmung erhellen!",
      "Schließen Sie die Augen, zählen Sie bis drei, die nächste Folie bringt Überraschungen! 1... 2... 3...",
      "Auf Abenteuer! Das Warten auf die nächste Folie ist so aufregend wie die Entdeckung eines Schatzes!",
      "Sind Sie bereit? Die nächste Folie nimmt Sie auf ein wunderbares Abenteuer mit!",
    ],
    Comprehensive: [
      "Stück für Stück erkunden Sie die endlose Welt des Spaßes!",
      "Von Themen zu Verzeichnissen und dann zu Inhaltsseiten, jeder Schritt ist eine Entdeckungsreise!",
      "Lassen Sie uns gemeinsam eine wunderbare Reise beginnen und unsere Spuren in dieser aufregenden Welt hinterlassen!",
      "Auf dieser überraschenden Website entdecken wir gemeinsam mehr!",
    ],
    Unpurchased: [
      "Lust zu probieren? Die nächste Folie startet ein visuelles Fest, kommen Sie und machen Sie mit!",
      "Mehr als nur Produkte, es ist ein Lebensstil! Klicken Sie zum Kaufen und lassen Sie Ihre Stimmung fliegen!",
      "Hier kaufen Sie nicht nur Produkte, sondern auch reichlich Glück!",
      "Werden Sie Mitglied und beginnen Sie ein neues Kapitel eines fröhlichen Lebens!",
      "Klicken Sie zum Kaufen und machen Sie jeden Tag voller Überraschungen und Spaß!",
      "Kaufen ist mehr als eine Aktion, es ist eine Art, das Leben zu genießen!",
      "Nutzen Sie die Gelegenheit, kaufen Sie Ihre gewünschten Produkte und machen Sie das Leben bunter!",
      "Kaufen ist ein wunderbares Abenteuer, lassen Sie uns gemeinsam auf diese Reise gehen!",
      "Klicken Sie zum Kaufen, bringen Sie sich eine Überraschung und Glück!",
      "Kaufen ist ein Ausdruck, lassen Sie uns gemeinsam mit Herz wählen!",
    ],
  },
};
